import GenericCreate from 'client/js/resellercp/generic_resource/create';
import Form from './form';

const Page = () => (<GenericCreate namespace="usercp" resource_name="cronjobs" defaults={{cronjob_type: 'url'}} redirectAfter="index" form_component={() => (<Form />)} />);

export default Page;
